import Fetch, { V1 } from 'Util/fetcher';

const ON_REQUEST_CONFIG = 'ON_REQUEST_CONFIG';
const ON_REQUEST_CONFIG_FAILURE = 'ON_REQUEST_CONFIG_FAILURE';
const ON_REQUEST_CONFIG_SUCCESS = 'ON_REQUEST_CONFIG_SUCCESS';

function onRequestConfig() {
  return {
    type: ON_REQUEST_CONFIG,
  };
}
function onRequestConfigSuccess(payload) {
  return {
    type: ON_REQUEST_CONFIG_SUCCESS,
    payload,
  };
}
function onRequestConfigFailure(payload) {
  return {
    type: ON_REQUEST_CONFIG_FAILURE,
    payload,
  };
}

export const onDoRequestConfig = () => (dispatch) => {
  dispatch(onRequestConfig());
  Fetch.get(`${V1}common/config/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestConfigSuccess(resp.json));
    } else {
      dispatch(onRequestConfigFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestConfigFailure(error.message));
  });
};

const INITIAL_STATE = {
  configLoading: false,
  configData: null,
  configError: null,
};

const config = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_CONFIG:
      return {
        ...state,
        configLoading: true,
        configData: null,
        configError: null
      };
    case ON_REQUEST_CONFIG_SUCCESS:
      return {
        ...state,
        configLoading: false,
        configData: action.payload,
        configError: null
      };
    case ON_REQUEST_CONFIG_FAILURE:
      return {
        ...state,
        configLoading: false,
        configData: null,
        configError: action.payload
      };
    default:
      return state;
  }
};

export default config;
